import Joi from 'joi';

export const ActivityMemoSchema = Joi.object({
  subject: Joi.string().required(),
});

export const ActivityMemoResultSchema = Joi.object({
  isDeleteMode: Joi.string().required(),
  activityDate: Joi.date().required(),
});

export const ActivityMemoResultAttachmentSchema = Joi.object({
  name: Joi.string().required(),
  file: Joi.string().required(),
});
